module.exports = __webpack_public_path__ + "static/agriculture-907b2a7185940724a8a97f17f9eeac2f.jpg";